import 'css-chunksrc/client/pages/projectPage/timeSheetPage/loader/allocation/recordList/styles.scss';export default {
  "recordList": "_recordList_10m15_1",
  "resource": "_resource_10m15_7",
  "record": "_record_10m15_1",
  "list": "_list_10m15_11",
  "task": "_task_10m15_15",
  "dates": "_dates_10m15_19",
  "odd": "_odd_10m15_31",
  "today": "_today_10m15_34",
  "weekEnd": "_weekEnd_10m15_37",
  "timeOverview": "_timeOverview_10m15_41"
};